/**
 * @ngdoc directive
 * @name ngBreakpointClass
 * @description Adds a class to the elem on certain breakpoints.
 * @param matchmedia
 * @param breakpoints
 * @returns {{restrict: string, scope: boolean, link: Function}}
 */
export default function ngBreakpointClass(matchmedia, breakpoints) {
  'ngInject';
  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function preLink($scope, $element, $attrs) {
          //Get bps as an array
          let bpKeys = Object.keys(breakpoints);
          //Map over breakpoints to match $attrs with breakpoints.
          bpKeys.map(function (key) {
            let norm = $attrs.$normalize(`bp-${key}`);
            if (norm in $attrs) {
              matchmedia.on(breakpoints[key], function (list) {
                if (list.matches) {
                  $element.addClass($attrs[norm]);
                }
                else {
                  $element.removeClass($attrs[norm]);
                }
              });
            }
          });
        }
      };
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/ngBreakpointClass/ngBreakpointClass.directive.js
 **/